import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MediaQuery from "react-responsive";
import Iframe from "react-iframe";
import { data } from "../data";
import { MathComponent } from "mathjax-react";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import "./Part2.css"
import "katex/dist/katex.min.css";
import { InlineMath } from "react-katex";
import MariMencoba1 from "../2/Marimencoba";
import MariMencoba2 from "../2/Marimencoba2";

import Chrevisi from "./Chrevisi";
import Chtambahan from "./Chtambahan";
import VideoPlayer from "react-video-js-player";

import Vid1 from "../2/Coba2/New folder/Vid1.mp4"
const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#40bf80",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const Part2 = () => {
	const VidTutorial = Vid1;
	const classes = useStyles();
	const { subbab2, materi2 } = data[1];
	const [chsoal0, setChsoal0] = useState(false);
	const [chsoal1, setChsoal1] = useState(false);
	// const [chsoal2, setChsoal2] = useState(false);
	const [chsoalR, setChsoalR] = useState(false);
	const [jawaban1, setJawaban1] = useState(false);
	// const [jawaban2, setJawaban2] = useState(false);
	const [show, setShow] = useState(false);
	const [show0, setShow0] = useState(false);
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const clickSetJawaban1 = () => setJawaban1(!jawaban1);
	// const clickSetJawaban2 = () => setJawaban2(!jawaban2);

	const clickSetChSoal1 = () => setChsoal1(!chsoal1);
	const clickSetChSoal0 = () => setChsoal0(!chsoal0);
	// const clickSetChSoal2 = () => setChsoal2(!chsoal2);
	const clickSetChSoalR = () => setChsoalR(!chsoalR);
	const [opendialog, setOpendialog] = React.useState(false);
	const [openmencobadialog, setOpenmencobadialog] = useState(false);
	const [openmencobadialog2, setOpenmencobadialog2] = useState(false);
	const openMencobaDialog2 = () => {
		setOpenmencobadialog2(true);
	};
	const closemencobaDialog2 = () => {
		setOpenmencobadialog2(false);
	};
	const openMencobaDialog = () => {
		setOpenmencobadialog(true);
	};
	const closemencobaDialog = () => {
		setOpenmencobadialog(false);
	};
	const openDialog = () => {
		setOpendialog(true);
	};

	const closeDialog = () => {
		setOpendialog(false);
	};
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "60px", height: "30px" });
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if(jwb === "5"){
			setForm1({
					border: "6px solid #1aff66",
					width: "50px",
					height: "30px",
			  })
			  setShow1(true)
			 } else if (jwb === ""){
			 setForm1({
					border: "6px solid yellow",
					width: "50px",
					height: "30px",
			  })
			}else{ setForm1({
					border: "6px solid red",
					width: "50px",
					height: "30px",
			  });
			}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if(jwb === "3"){
			setForm2({
					border: "6px solid #1aff66",
					width: "50px",
					height: "30px",
			  })
			  setShow2(true)
			 } else if (jwb === ""){
			 setForm2({
					border: "6px solid yellow",
					width: "50px",
					height: "30px",
			  })
			}else{ setForm2({
					border: "6px solid red",
					width: "50px",
					height: "30px",
			  });
			}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		jwb === "5,0"
			? setForm3({
					border: "6px solid #1aff66",
					width: "50px",
					height: "30px",
			  })
			: jwb === ""
			? setForm3({
					border: "6px solid yellow",
					width: "50px",
					height: "30px",
			  })
			: setForm3({
					border: "6px solid red",
					width: "50px",
					height: "30px",
			  });
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,3") {
			setShow0(true)
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			})
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "BENAR") {
			setShow(true)
			setForm5({
				border: "6px solid #1aff66",
				width: "60px",
				height: "30px",
			})
		} else if (jwb === "") {
			setForm5({
				border: "6px solid yellow",
				width: "60px",
				height: "30px",
			});
		} else {
			setForm5({
				border: "6px solid red",
				width: "60px",
				height: "30px",
			});
		}
	};

	return (
		<div
			className="container"
			style={{
				width: "100%",
				textAlign: "justify",
				lineHeight: "35px",
			}}
		>
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
			<div className="row">
				<div
					className="col-md-4 col-lg"
					style={{
						color: "green",
						fontSize: `${ukuranH}px`,
					}}
				>
					<strong>{subbab2}</strong>
				</div>
			</div>
			<div className="row">
				<p style={{fontSize:`${ukuranP}px`}} className="col-sm-12 col-md col-lg">{materi2}</p>
			</div>

			<div style={{ marginTop: "1rem" }}>
				<ul style={{fontSize:`${ukuranP}px`}}>
					<li>Tentukan dua titik potong:</li>
					<ol>
						<li>Cari titik potong terhadap sumbu y, maka x = 0,</li>
						<li>Cari titik potong terhadap sumbu x, maka y = 0,</li>
					</ol>
					<p>Maka akan menghasilkan titik koordinat (x, 0 ) dan (0 , y ).</p>
					<li>
						Subtitusikan (0,0) ke dalam variabel x dan y dalam pertidaksamaan.
					</li>
					<li>Arsir daerah himpunan dengan ketentuan:</li>
					<ol>
						<li>
							Jika bernilai <strong>benar</strong>, maka daerah yang memuat
							titik (0,0) merupakan daerah penyelesaian. Arsir daerah yang bukan
							penyelesaian, yang tidak memuat titik (0,0).
						</li>
						<li>
							Jika bernilai <b>salah</b>, maka daerah yang memuat titik (0,0)
							bukan daerah penyelesaian. Arsir daerah yang memuat titik (0,0).
						</li>
					</ol>
					<p>
						Penyelesaian dari pertidaksamaan linier dalam variabel <i>x</i> dan{" "}
						<i>y</i> adalah semua nilai <i>x</i> dan <i>y</i> yang memenuhi
						pertidaksamaan tersebut.
					</p>
					<p style={{ marginTop: "1rem" }}>
						Untuk memahaminya klik tombol contoh soal berikut :
					</p>
				</ul>
				<div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoal0()}
						className="btn btn-outline-success btn-sm  mb-2"
					>
						{" "}
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Contoh Soal
						</h6>
					</div>
					<div>{chsoal0 ? <Chtambahan ukuranH={ukuranH} ukuranP={ukuranP}/> : null}</div>
				</div>
				</div>
			</div>
			<div style={{fontSize:`${ukuranP}px`}} className="text-center">Setelah membaca dan memahami contoh soal di atas, selanjutnya kerjakan latihan di bawah ini !</div>
			<div className="row">
				<div className="col">
					<div
						className="card mt-2 border-success"
						style={{ borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<strong style={{fontSize:`${ukuranH}px`}} className="text-white text-center">Petunjuk Pengerjaan</strong>
						</div>
						<div className="card-body">
							<ol style={{fontSize:`${ukuranP}px`}}>
								<li>Perhatikan dengan teliti !</li>
								<li>Kalian harus mengisi form yang kosong</li>
								<li>Apabila benar maka border form akan berwarna hijau, kemudian akan tampil lanjutannya</li>
								<li>Apabila salah maka border form akan berwarna merah</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div className="d-grid gap-2">
					<div
						onClick={() => clickSetChSoalR()}
						className="btn btn-outline-success btn-sm mt-2 mb-3"
					>
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 1
						</h6>
					</div>
				</div>
				<div>{chsoalR ? <Chrevisi ukuranH={ukuranH} ukuranP={ukuranP}/> : null}</div>
			</div>
			<div>
				<div className="d-grid gap-2">
					<button
						onClick={() => clickSetChSoal1()}
						className="btn btn-outline-success border-success shadow rounded mb-3"
					>
						{" "}
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 2
						</h6>
					</button>
				</div>
				{chsoal1 ? (
					<div>
						<div
							className="shadow rounded mt-2"
							style={{
								margin: "auto",
								lineHeight: "35px",
								textAlign: "justify",
								width: "100%",
								borderStyle: "inset",
								borderRadius: "25px",
								borderColor: "#70db70",
							}}
						>
							<div className="row">
								<div className="col">
									<div style={{ display: "flex", justifyContent: "center" }}>
										<p style={{ paddingLeft: "10px",fontSize:`${ukuranP}px` }}>
											Gambarlah daerah penyelesaian dari
											<MathComponent tex={String.raw`3x + 5y ≤ 15 ! `} />
										</p>
									</div>
								</div>
							</div>
							<div className="container">
								<div
									style={{
										color: "green",
										display: "flex",
										justifyContent: "space-between",
										width: "10%",
									}}
								>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.3s alternate ease infinite",
										}}
									>
										<SkipNextIcon />
									</div>
									<p
										style={{ marginLeft: "22px", cursor: "pointer" }}
										onClick={clickSetJawaban1}
									>
										<strong>
											<u>Jawaban</u>
										</strong>
									</p>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.3s alternate ease infinite",
										}}
									>
										<SkipPreviousIcon />
									</div>
								</div>
								{jawaban1 ? (
									<div>
										<ol>
										
												<ol style={{fontSize:`${ukuranP}px`}}>
												<li>
													Pertama kita buat dalam bentuk tabel bahwa :
												</li>
												<p>
													<MathComponent tex={String.raw`3x + 5y = 15`} />
												</p>
												<p className="text-center alert alert-warning h6">Lengkapi form di bawah ini dengan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y "/></p>
												<div class="d-flex justify-content-center">
													<table
														style={{
															border: "2px solid green",
															borderCollapse: "collapse",
															width: "30%",
															textAlign: "center",
															marginBottom: "1rem",
														}}
													>
														<tr>
															<th
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>x</i>
															</th>
															<th
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<input
																	style={form1}
																	onChange={handleform1}
																	type="text"
																/>
															</th>
															<th
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>0</i>
															</th>
														</tr>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>y</i>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>0</i>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<input
																	style={form2}
																	onChange={handleform2}
																	type="text"
																/>
															</td>
														</tr>
													</table>
												</div>
									{show1&&show2 ? 
									<>
													<p className="text-center">Maka didapatkan titik koordinat :</p>
													<div className="d-flex justify-content-center mt-2 mb-2">
													<table
														style={{
															border: "2px solid green",
															borderCollapse: "collapse",
															width: "30%",
															textAlign: "center",
															marginBottom: "1rem",
														}}
													>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<h5>Titik Koordinat (... , ...)</h5>
															</td>
														</tr>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>A = (
																<input
																	type="text"
																	style={form3}
																	onChange={handleform3}
																/> )
															</td>
														</tr>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
															B =	(
																<input
																	type="text"
																	style={form4}
																	onChange={handleform4}
																/>
																)
															</td>
														</tr>
													</table>
												</div>
												{show0 ? (
													<>
														<div className="row">
															<div className="alert alert-success col-sm-6 offset-sm-3 mt-2">
																<h6 className="text-center">Yeay kamu benar</h6>
															</div>
														</div>
														<p className="alert alert-secondary">Setelah mendapatkan titik koordinat A dan titik koordinat B, maka hubungkan titik koordinat A dan titik koordinat B sehigga menjadi garis persamaan. Maka hasilnya seperti di bawah ini !</p>
														<div className="d-flex justify-content-center">
															<ul>
																<MediaQuery minWidth={476} maxWidth={1824}>
																	<Iframe
																		scrolling="no" title="Ch1" src="https://www.geogebra.org/material/iframe/id/h3pb3ztp/width/502/height/406/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="502px" height="406px" allowFullScreen
																	></Iframe>
																</MediaQuery>

																<MediaQuery maxWidth={475}>
																	<Iframe
																		scrolling="no" title="Ch1" src="https://www.geogebra.org/material/iframe/id/h3pb3ztp/width/502/height/406/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
																		width="100%"
																		style={{ border: "0px", height: "300px" }}
																		allowFullScreen
																	></Iframe>
																</MediaQuery>
															</ul>
														</div>
										
											<li>Menentukan daerah penyelesaian</li>
											
												<li style={{ listStyleType: "lower-alpha" }}>
													Substitusikan <i>(0,0)</i>, sehingga
												</li>
												<div className="row">
													<div className="col-sm-2 col-md-12 col-lg-12">
														<ul style={{ width: "100%", position: "relative" }}>
															<li>
																<InlineMath math="3(0) + 5(0) ≤  15" />
															</li>
															<li>
																<InlineMath math="0 ≤  15" />
															</li>
															<li>
																pertidaksamaan bernilai{" "}
																<input
																	type="text"
																	style={form5}
																	onChange={handleform5}
																/>
															</li>
														</ul>
													</div>
												</div>
												{show ? (
													<div>
														<p>
															Selanjutnya, coba kamu lakukan apa yang diperintahkan pada grafik di bawah ini
															{/* Maka daerah himpunan ialah daerah yang tidak
															mengenai arsiran. Maka diperoleh daerah
															penyelesaiannya seperti berikut */}
														</p>
														<div className="d-flex justify-content-center">
															<ul>
																<MediaQuery minWidth={476} maxWidth={1824}>
																	<Iframe
 scrolling="no" title="Ch1Part2" src="https://www.geogebra.org/material/iframe/id/zunz5nhp/width/700/height/450/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="700px" height="450px" allowFullScreen
																	/>
																</MediaQuery>
																<MediaQuery maxWidth={475}>
																	<Iframe
scrolling="no" title="Ch1Part2" src="https://www.geogebra.org/material/iframe/id/zunz5nhp/width/700/height/450/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
																		width="100%"
																		style={{ height: "300px", border: "0px" }}
																		allowFullScreen
																	/>
																</MediaQuery>
															</ul>
														</div>
														<button
													className="btn btn-success"
													onClick={openDialog}
												>
													Keterangan
												</button>
														<p className="text-center alert alert-danger h6 mt-3 mb-3">
															Kalian harus menonton video di bawah ini agar mudah dalam mengerjakan mari mencoba!
														</p>
														<div className="d-flex justify-content-center">
															
																<MediaQuery minWidth={476} maxWidth={1824}>
																<VideoPlayer 
																src={VidTutorial}
																width="800"
																height="500"
																/>
																</MediaQuery>
																<MediaQuery maxWidth={475}>
																<VideoPlayer 
																src={VidTutorial}
																width="300"
																height="100"
																/>
																</MediaQuery>
															
														</div>
														<div className="text-center"><i><b>Video cara mencari daerah penyelesaian dari pertidaksamaan</b></i></div>
														
														<div>
												<p className="alert alert-warning" style={{ textAlign: "center" }}>
													Selanjutnya agar memperdalam pemahaman kamu, Ayo mari
													mencoba{" "}
												</p>

												<div className="d-flex justify-content-center align-items-center">
													<button
														className="btn btn-outline-success btn-sm"
														onClick={openMencobaDialog}
													>
														<p
															style={{
																animation:
																	"scrollTop 0.3s alternate ease infinite",
															}}
														>
															Mari Mencoba 1
														</p>
													</button>
												</div>
												<div className="d-flex justify-content-center align-items-center">
													<button
														className="btn btn-outline-success btn-sm mt-2 mb-2"
														onClick={openMencobaDialog2}
													>
														<p
															style={{
																animation:
																	"scrollTop 0.3s alternate ease infinite",
															}}
														>
															Mari Mencoba 2
														</p>
													</button>
												</div>
											</div>
									
													</div>
												) : null}

												
													</>
												) : null}
									</>
									:null}

										
												<Dialog
													open={opendialog}
													onClose={closeDialog}
													aria-labelledby="alert-dialog-title"
													aria-describedby="alert-dialog-description"
												>
													<DialogTitle id="alert-dialog-title">
														{"Keterangan"}
													</DialogTitle>
													<DialogContent>
														<DialogContentText id="alert-dialog-description">
															<div>
																<p>Perhatikan untuk daerah penyelesaian :</p>
																<ul>
																	<li>
																		Daerah yang <b>tidak arsir</b> merupakan
																		daerah penyelesaian.
																	</li>
																</ul>
															</div>
														</DialogContentText>
													</DialogContent>
													<DialogActions>
														<Button onClick={closeDialog}>
															<div style={{ color: "green" }}>
																Inggih ulun mengerti
															</div>
														</Button>
													</DialogActions>
												</Dialog>
											</ol>
										</ol>
									</div>
								) : null}
							</div>
						</div>
					</div>
				) : null}
			</div>
			
			<div>
				<div>
					<Dialog
						fullScreen
						open={openmencobadialog}
						onClose={closemencobaDialog}
						TransitionComponent={Transition}
					>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton
									edge="start"
									color="inherit"
									onClick={closemencobaDialog}
									aria-label="close"
								>
									<CloseIcon />
								</IconButton>
								<h4 className={classes.title}>Mari Mencoba 1</h4>
							</Toolbar>
						</AppBar>

						<MariMencoba1 ukuranH={ukuranH} ukuranP={ukuranP}/>
					</Dialog>
				</div>

				<div>
					<Dialog
						fullScreen
						open={openmencobadialog2}
						onClose={closemencobaDialog2}
						TransitionComponent={Transition}
					>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton
									edge="start"
									color="inherit"
									onClick={closemencobaDialog2}
									aria-label="close"
								>
									<CloseIcon />
								</IconButton>
								<h4 className={classes.title}>Mari Mencoba 2</h4>
							</Toolbar>
						</AppBar>

						<MariMencoba2 ukuranH={ukuranH} ukuranP={ukuranP} />
					</Dialog>
				</div>
			</div>
		</div>
	);
};

export default Part2;
